
import { buildFluidSrcSet, buildSrc } from '@Utils/images';
import {
  MqMaxWidthDesktopLarge,
  MqMaxWidthTabletMedium,
  MqMaxWidthTabletXlarge,
} from '@Tokens/tokens.json';

export default {
  name: 'EditoMedia',
  props: {
    /**
     * Media intro
     * @see elements/edito-text
     */
    intro: {
      type: Object,
      default: undefined,
    },
    /**
     * Push image
     */
    img: {
      type: [Object, String],
      default: undefined,
    },
    /**
     * Youtube video
     */
    video: {
      type: String,
      default: undefined,
    },
    /**
     * Youtube title
     */
    videoTitle: {
      type: String,
      default: undefined,
    },
  },
  computed: {
    imgAttributes() {
      if (!this.img) {
        return undefined;
      }

      return {
        alt: this.img.alt || '',
        loading: 'lazy',
        sizes: `${MqMaxWidthTabletMedium} 95vw, ${MqMaxWidthTabletXlarge} 90vw, ${MqMaxWidthDesktopLarge} 75vw, 1056px`,
        src: buildSrc({
          format: 'jpg',
          img: this.img,
          size: 1056,
        }),
        srcset: buildFluidSrcSet({
          format: 'jpg',
          img: this.img,
          sizes: [335, 560, 670, 760, 1060, 1120, 1260, 1500, 1700, 1900, 2100],
        }),
        width: '1056',
      };
    },
  },
};
